export default "__VITE_ASSET__BZmXA8zr__"